import React, { useState } from 'react';
import axios from 'axios';
import { api } from '../App';
import TTSBar from './TTSBar';

const LANGS = [
  { code: 'fr', label: '🇫🇷 Français' },
  { code: 'en', label: '🇬🇧 Anglais' },
  { code: 'es', label: '🇪🇸 Espagnol' },
  { code: 'de', label: '🇩🇪 Allemand' },
  { code: 'pt', label: '🇧🇷 Portugais' },
  { code: 'it', label: '🇮🇹 Italien' },
  { code: 'ar', label: '🇸🇦 Arabe' },
  { code: 'ja', label: '🇯🇵 Japonais' },
];

export default function LyricsPage() {
  const [artist, setArtist] = useState('');
  const [title, setTitle] = useState('');
  const [lang, setLang] = useState('fr');
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);
  const [error, setError] = useState('');
  const [showTranslation, setShowTranslation] = useState(false);
  const [explaining, setExplaining] = useState(false);
  const [explanation, setExplanation] = useState('');

  const fetchLyrics = async () => {
    if (!artist.trim() || !title.trim()) return;
    setLoading(true); setError(''); setData(null); setExplanation('');
    try {
      const r = await axios.get(`${api}/lyrics`, { params: { artist, title, lang } });
      setData(r.data);
    } catch {
      setError('Paroles introuvables. Vérifie l\'artiste et le titre.');
    } finally {
      setLoading(false);
    }
  };

  const explain = async () => {
    if (!data) return;
    setExplaining(true);
    try {
      const r = await axios.post(`${api}/ai/explain`, { lyrics: data.lyrics, title, artist });
      setExplanation(r.data.explanation);
    } catch {}
    setExplaining(false);
  };

  return (
    <div className="page">
      <div className="url-box">
        <h2>🎵 Paroles & Traduction</h2>
        <input
          className="url-input" style={{marginBottom:10,width:'100%',display:'block'}}
          placeholder="Artiste (ex: Bob Marley)"
          value={artist}
          onChange={e => setArtist(e.target.value)}
        />
        <input
          className="url-input" style={{marginBottom:10,width:'100%',display:'block'}}
          placeholder="Titre (ex: No Woman No Cry)"
          value={title}
          onChange={e => setTitle(e.target.value)}
          onKeyDown={e => e.key === 'Enter' && fetchLyrics()}
        />
        <div style={{display:'flex',gap:8,alignItems:'center'}}>
          <select className="lang-select" value={lang} onChange={e => setLang(e.target.value)}>
            <option value="original">Langue originale</option>
            {LANGS.map(l => <option key={l.code} value={l.code}>{l.label}</option>)}
          </select>
          <button className="btn-primary" onClick={fetchLyrics} disabled={loading}>
            {loading ? <span className="loader"/> : '🔍'}
          </button>
        </div>
      </div>

      {error && <div className="error-msg">⚠️ {error}</div>}

      {data && (
        <>
          <div style={{display:'flex',gap:8,flexWrap:'wrap',marginBottom:8}}>
            <div className="badge">🎤 {data.artist}</div>
            <div className="badge">🎵 {data.title}</div>
          </div>

          <TTSBar text={data.lyrics} lang="original" label="Lire les paroles"/>

          {data.translation && (
            <div style={{display:'flex',gap:8,marginBottom:8}}>
              <button className="btn-secondary" onClick={() => setShowTranslation(!showTranslation)}>
                {showTranslation ? '📝 Voir original' : '🌍 Voir traduction'}
              </button>
              {showTranslation && <TTSBar text={data.translation} lang={lang} label="Lire traduction" inline/>}
            </div>
          )}

          <div className="lyrics-box">
            {!showTranslation || !data.translation ? (
              <div className="lyrics-text">{data.lyrics}</div>
            ) : (
              <>
                <div style={{fontSize:11,color:'var(--text2)',marginBottom:8}}>🌍 TRADUCTION</div>
                <div className="lyrics-translation">{data.translation}</div>
              </>
            )}
          </div>

          <div style={{display:'flex',gap:8,marginTop:12,flexWrap:'wrap'}}>
            <button className="btn-secondary" onClick={explain} disabled={explaining}>
              {explaining ? <><span className="loader"/> Analyse...</> : '💡 Expliquer la chanson'}
            </button>
          </div>

          {explanation && (
            <div className="lyrics-box" style={{marginTop:12,borderColor:'rgba(6,182,212,0.3)'}}>
              <div style={{fontSize:12,color:'var(--cyan)',marginBottom:8,fontWeight:700}}>💡 ANALYSE IA</div>
              <div style={{fontSize:14,lineHeight:1.7,whiteSpace:'pre-line'}}>{explanation}</div>
            </div>
          )}
        </>
      )}

      {!data && !loading && (
        <div style={{textAlign:'center',color:'var(--text2)',marginTop:60}}>
          <div style={{fontSize:48}}>🎤</div>
          <div style={{marginTop:12,fontSize:15}}>Entre un artiste et un titre pour voir les paroles</div>
        </div>
      )}
    </div>
  );
}
